export enum RegisterType {
  Outgoing = 'Outgoing',
  Incoming = 'Incoming',
  Internal = 'Internal',
  None = 'None'
}
